const ItemTypes = {
  BOX: "box",
  BRANDING_CARD: "branding-card",
};

export default ItemTypes;
